import React from "react";
import Image from "next/image";
import { Br } from "../molecules/Br";

// アイコンのパスは仮のものです
const features = [
  {
    icon: "/onstep/icons/member.svg",
    title: "会員（ファン）管理",
    description:
      "会員の基本情報からサービス更新に沿った情報まで、一元管理できます。",
  },
  {
    icon: "/onstep/icons/subscription.svg",
    title: "サブスクリプション管理",
    description:
      "会費や定期お届け商品など、さまざまな定額課金商品の設定が可能です。",
  },
  {
    icon: "/onstep/icons/ecommerce.svg",
    title: "E-Commerce",
    description:
      "物販製電子媒体まで対応。一般と会員で価格を分けるなど柔軟に設定できます。",
  },
  {
    icon: "/onstep/icons/video.svg",
    title: "動画配信",
    description:
      "高画質な動画を簡単にアップロード・配信。会員限定公開や有料配信などの設定が可能です。",
  },
  {
    icon: "/onstep/icons/content.svg",
    title: "コンテンツ配信",
    description:
      "会費や定期お届け商品など、さまざまな定額課金商品の設定が可能です。",
  },
  {
    icon: "/onstep/icons/event.svg",
    title: "イベント管理",
    description:
      "オンラインからリアルまで、チケット販売から参加者リスト作成まで運営をサポートします。",
  },
  {
    icon: "/onstep/icons/crowdfunding.svg",
    title: "クラウドファンディング",
    description:
      "ファンマーケティングとクラウドファンディングを組み合わせ、ファンとの絆を深めます。",
  },
  {
    icon: "/onstep/icons/sales.svg",
    title: "売上管理",
    description: "すべての売上を一元管理。分析に必要なローデータも提供します。",
  },
];
const caseStudies = [
  {
    logo: "/onstep/bnr-ethical.webp",
    name: "エシカルマルシェ",
    url: "https://ethicalmarche.jp",
    description: "つくり手との新しいつながりをつくる応援サイト",
  },
  {
    logo: "/onstep/bnr-meetal.webp",
    name: "Meetal",
    url: "https://meetal.net",
    description: "ミータルは無料のプリマ",
  },
  {
    logo: "/onstep/bnr-posimov.webp",
    name: "ポジデン動画.com",
    url: "https://posiden-mov.com",
    description: "無駄な投資をする前に！！驚愕商材の真実ノウハウが満載",
  },
];

// FeatureCardコンポーネント
const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="flex flex-col items-center gap-4 md:items-start">
      <div className="flex h-[64px] w-[64px] items-center justify-center rounded-full border bg-gray-50">
        <Image
          src={icon}
          alt={title}
          width={64}
          height={64}
          quality={80}
          className="object-contain"
        />
      </div>
      <div className="flex flex-col items-start gap-1">
        <h3 className="font-bold text-pri fluid-text-[14px,18px]">{title}</h3>
        <p className="font-bold leading-relaxed text-txt-light fluid-text-[12px,16px]">
          {description}
        </p>
      </div>
    </div>
  );
};

// CaseStudyCardコンポーネント
const CaseStudyCard = ({ logo, url, name, description }) => {
  return (
    <div className="box-border overflow-hidden rounded-lg border border-solid border-bdc-light group-hover:border-hov group-hover:opacity-80">
      <a href={url} className="group" target="_blank" rel="noreferrer">
        <div className="flex aspect-16/9 w-full items-center justify-center">
          <Image
            src={logo}
            alt={name}
            width={316}
            height={178}
            quality={80}
            priority={false}
            fill
          />
        </div>
        <div className="box-border border border-solid border-bdc-light px-4 py-3">
          <h3 className="mb-1 font-bold group-hover:text-hov">{name}</h3>
          <p className="line-clamp-2 text-txt-light fluid-text-[11px,14px] group-hover:text-hov">
            {description}
          </p>
        </div>
      </a>
    </div>
  );
};

// メインコンポーネント
export default function OnstepCapabilities() {
  return (
    <div className="mx-auto max-w-screen-xl px-8 py-16 md:py-24">
      <div className="relative z-10 flex flex-col gap-4 md:max-w-7xl md:gap-6">
        <div className="space-y-4 md:space-y-8">
          <div className="space-y-2">
            <h3 className=" font-bold text-ter fluid-text-[16px,22px]">
              Capabilities of ONSTEP
            </h3>
          </div>
          <h2 className=" font-bold text-pri fluid-text-[22px,45px]">
            ONSTEPでできること
          </h2>
        </div>
      </div>
      {/* 機能一覧 */}
      <div className="my-10 grid grid-cols-2 gap-8 md:my-20 md:grid-cols-2 md:gap-12 lg:grid-cols-3">
        {features.map((feature, index) => (
          <FeatureCard
            key={index}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>

      {/* 導入事例 */}
      <div className="mb-8">
        <h2 className="mb-8 text-center font-bold text-gray-500">
          ONSTEPの導入事例
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-8">
        {caseStudies.map((caseStudy, index) => (
          <CaseStudyCard
            key={index}
            url={caseStudy.url}
            logo={caseStudy.logo}
            name={caseStudy.name}
            description={caseStudy.description}
          />
        ))}
      </div>
    </div>
  );
}

// 他のファイルからも使用できるように、コンポーネントをエクスポート
export { FeatureCard, CaseStudyCard };
